import { ethers as o } from "ethers";
import { BulletContractAbi as e } from "@deorderbook/contracts/abi";
import { signer as c, provider as l } from "./provider.mjs";
const s = /* @__PURE__ */ new Map(), a = (t) => {
  const n = new o.Contract(
    t,
    e
  );
  return s.set(t, n), n;
}, p = (t, n = !1) => {
  const r = a(t);
  return n ? r.connect(c) : r.connect(l);
};
export {
  s as bulletContracts,
  a as initBulletContract,
  p as useBulletContract
};
//# sourceMappingURL=bulletContract.mjs.map
